import React from "react";

const ModalOverlay = ({ children, style, onPress = null }) => {
  return (
    <div
      onClick={onPress ? onPress : () => {}}
      className={"deal-modal-overlay animated fadeIn"}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%"
        }}
      >
        {children}
      </div>
    </div>
  );
};

export { ModalOverlay };
